import React, { Suspense } from "react";
import { useLocation } from "react-router-dom";
import { ActionButton } from "@culturehq/components";

import { t } from "app/utils";

import getText from "components/editor/getText";

const AddToCalendar = React.lazy(() => import("./AddToCalendar"));

const LazyAddToCalendar = ({ children, event }) => {
  const location = useLocation();

  const addToCalendarEvent = { ...event, details: getText(event.details) };
  const label = children || t("Add to My Calendar");

  return (
    <Suspense fallback={<ActionButton>{label}</ActionButton>}>
      <AddToCalendar event={addToCalendarEvent} open={location.hash === "#calendar"}>
        {label}
      </AddToCalendar>
    </Suspense>
  );
};

export default LazyAddToCalendar;
